import React from 'react';
import PropTypes from 'prop-types'

import TextField from 'material-ui/TextField';
import { Tabs, Tab } from 'material-ui/Tabs';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';

import isURL from 'validator/lib/isURL';
import isEmpty from 'validator/lib/isEmpty';

import Uploader from '../../util/uploader';
import AmpFormSeparationChar from '../../components/AmpFormSeparationChar';
import AmpFormUidColumnIndex from '../../components/AmpFormUidColumnIndex';
import StepProps from '../../constants/StepProps';

const styles = {
  flexBox: {
    display: 'flex'
  },
  flexLeft: {
    flex: '2 0 0',
    margin: '8px 8px 8px 0',
  },
  flexRight: {
    flex: '0.7 0 0',
    margin: '8px 0px 0px 40px',
  },
  uploadButton: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
  extraPadding: {
    padding: 20,
  },
  spacer: {
    paddingLeft: 20,
  },
  tabContainer: {
    // background: '#f1f1f1',
  },
  tab: {
    // color: 'black',
  },
  notification: {
    background: 'rgb(244, 244, 244)',
    color: 'rgb(101, 101, 101)',
    padding: 13,
    fontSize: 14,
    fontStyle: 'italic',
  },
};


class AmplificationSourceForm extends React.Component {
  static propTypes = StepProps;
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    datasetLocation: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedFileName: '...',
      separationChar: 'auto',
      uidColumnIndex: 0,
      inputMethod: 'from_file',
      fromFile: null,
      fromUrl: '',
      fromText: '',
      showColumnSettings: false,
    };

    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.handleUrlChange = this.handleUrlChange.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleFileSelect(e) {
    let selectedFileName = (e.target.files[0] && e.target.files[0].name) || '...';
    this.setState({
      selectedFileName,
      fromFile: e.target.files[0],
    }, this.validateResults);
  }

  handleUrlChange(e) {
    this.setState({
      fromUrl: e.target.value,
    }, this.validateResults);
  }

  handleTextChange(e, value) {
    this.setState({
      fromText: e.target.value,
    }, this.validateResults);
  }

  handleTabChange(value) {
    this.setState({
      inputMethod: value,
    }, this.validateResults);
  }

  handleSeparatorChange = (value) => {
    this.setState({
      separationChar: value,
    }, this.validateResults);
  }

  handleUidColumnChange = (value) => {
    this.setState({
      uidColumnIndex: value,
    }, this.validateResults);
  }

  handleShowColumnSettingsChange = (event, isChecked) =>
    this.setState({showColumnSettings: isChecked});

  complete() {
    // Create form commands and send this to the back-end
    const data = {};
    let uploadAction = '';
    let {fromFile, fromUrl, fromText, separationChar, uidColumnIndex, showColumnSettings} = this.state;
    switch (this.state.inputMethod) {
      case 'from_file':
        data.file = fromFile;
        uploadAction = 'file';
        break;
      case 'from_url':
        data.url = fromUrl;
        uploadAction = 'url';
        break;
      case 'from_text':
        data.text = fromText;
        uploadAction = 'form';
        break;
      default:
        break;
    }
    if (!showColumnSettings) {
      uidColumnIndex = 0;
      separationChar = 'auto';
    }
    data.uid_column_index = uidColumnIndex;
    data.separation_char = separationChar;

    // TODO: Cancel upload when user navigates!
    Uploader.init(this.context.firebaseToken)
      .uploadFile(uploadAction, data, this.context.dataset, this.context.datasetLocation, 'amp')
      .then(this.props.onStepCompleteSuccess)
      .catch(this.props.onStepCompleteFailed);
  }

  validateResults(props = this.props, state = this.state) {
    let valid = false;
    switch (state.inputMethod) {
      case 'from_file':
        valid = !!state.fromFile;
        break;
      case 'from_url':
        valid = isURL(state.fromUrl);
        break;
      case 'from_text':
        valid = !isEmpty(state.fromText);
        break;
      default:
        break;
    }

    valid = valid && !isEmpty(state.separationChar);

    props.onValidationChange(valid);
  }

  render() {
    // Styles to animate appearance of column settings panel
    let columnSettingsStyle = {
      height: this.state.showColumnSettings ? "auto" : 0,
      opacity: this.state.showColumnSettings ? 1: 0,
      transform: this.state.showColumnSettings ? "translateY(0)" : "translateY(-10px)",
      overflow: "hidden",
      transition: "opacity 0.5s ease, transform 0.5s ease",
    }

    return (
      <div>
        <Paper zDepth={1} className="ContentSpacing">
          <div style={styles.flexBox}>
            <div style={styles.flexLeft}>
              <h3>Source data selection</h3>
              <Paper zDepth={1}>
                <Tabs
                  tabItemContainerStyle={styles.tabContainer}
                  value={this.state.inputMethod}
                  onChange={this.handleTabChange}>
                  <Tab label="From file" style={styles.tab} value="from_file">
                    <div style={styles.extraPadding}>
                      <p>Please select CSV or TSV a file that contains the UIDs you would like to amplify:</p>
                      <RaisedButton
                        label="Select file"
                        labelPosition="before"
                        style={styles.button}
                        containerElement="label"
                      >
                        <input type="file"
                          accept=".csv, .csv.gz, .tsv, .tsv.gz"
                          onChange={this.handleFileSelect}
                          style={styles.uploadButton}
                        />
                      </RaisedButton><span style={styles.spacer}></span><i>{this.state.selectedFileName}</i>
                    </div>
                  </Tab>
                  <Tab label="From URL" style={styles.tab} value="from_url">
                    <div style={styles.extraPadding}>
                      <TextField
                        hintText="https:/your.url.here/"
                        onChange={this.handleUrlChange}
                        errorStyle={styles.errorStyle}
                        errorText={this.state.fromUrl.length > 4 && !isURL(this.state.fromUrl) && "A valid URL is required"}
                        floatingLabelFixed={true}
                        fullWidth={true}
                      />
                    </div>
                  </Tab>
                  <Tab label="From text" style={styles.tab} value="from_text">
                    <div style={styles.extraPadding}>
                      Add your enter-separated UIDs or paste CSV content here:
                      <TextField
                        hintText="e.g.: b601efaa5769254b2c48d1f3a594c77e↵ n30c11475750271f20fd8fdf1621323b2↵ .."
                        onChange={this.handleTextChange}
                        multiLine={true}
                        fullWidth={true}
                        rows={4}
                        rowsMax={14}
                      />
                    </div>
                  </Tab>
                </Tabs>
              </Paper>
            </div>

            <div style={styles.flexRight}>
              <h3>Source settings</h3>
              <Checkbox
                label="My source contains additional columns"
                onCheck={ this.handleShowColumnSettingsChange }
              />
              <div
                style={columnSettingsStyle}
              >
                  <h4 style={{marginBottom:3}}>Which column contains your UIDs?</h4>
                  <AmpFormUidColumnIndex
                    onChange={this.handleUidColumnChange}
                    defaultValue={this.state.uidColumnIndex}
                  />

                  <h4 style={{marginBottom:16}}>Separation character</h4>
                  <AmpFormSeparationChar
                    onChange={this.handleSeparatorChange}
                    defaultValue={this.state.separationChar}
                    showAuto={true}
                  />
              </div>
            </div>
          </div>
          <br/>
        </Paper>
      </div>
    )
  }
}
export default AmplificationSourceForm;



// WEBPACK FOOTER //
// ./src/components/AmpStepSourceForm/index.jsx